import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { getL10nBase, getSheetEnv } from '@/lib/cdnBase';
import { cn } from '@/lib/utils';
import { useLocaleStore, type LocaleMode } from '../lib/locale-store';
import { loadTranslations, isLoaded } from '../lib/translations';

const MODES: LocaleMode[] = ['KEY', 'EN', 'KO'];

export function LocaleToggle() {
  const { mode, setMode } = useLocaleStore();

  useEffect(() => {
    const cdnBase = getL10nBase(getSheetEnv());
    if (mode === 'EN' && !isLoaded('en')) void loadTranslations('en', cdnBase);
    if (mode === 'KO' && !isLoaded('ko')) void loadTranslations('ko', cdnBase);
  }, [mode]);

  return (
    <div className="inline-flex rounded-md border border-border" role="tablist" aria-label="Locale">
      {MODES.map((m) => (
        <Button
          key={m}
          type="button"
          variant={mode === m ? 'default' : 'ghost'}
          size="sm"
          className={cn(
            'rounded-none first:rounded-l-md last:rounded-r-md',
            mode === m && 'shadow-none'
          )}
          onClick={() => setMode(m)}
        >
          {m}
        </Button>
      ))}
    </div>
  );
}
